import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import NotesComponent from '../../../components/orders-drawer/sections/notes';
import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';
import { OrderDrawerSection } from '../../../enums/order-drawer-section';

const sectionId = OrderDrawerSection.notes;

const mapStatesToProps = (state, { fulfillmentPlanIds }) => {
  const [fulfillmentPlanId] = fulfillmentPlanIds;
  const notes =
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'notes',
    }) || emptyArray;
  return {
    fulfillmentPlanId,
    notes,
    ...mapStateToOpen(state, sectionId),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...mapDispatchToOnClick(dispatch, sectionId),
  };
};

export const NotesSectionContainer = connect(mapStatesToProps, mapDispatchToProps);
export const Notes = NotesSectionContainer(NotesComponent);
